import { createStyles, makeStyles, Theme } from '@material-ui/core';

import theme from '../../theme';
import { PrompterConfig } from './utils';

export const StudioControlStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  root: {
    borderTop: `solid 1px ${palette.studio.borderColor}`,
    margin: 'auto',
    width: '100%',
  },
  commonStudioAction: {
    width: '55px',
  },
  panelSettings: {
    borderTop: `1px solid ${palette.studio.borderColor}`,
    borderRight: `1px solid ${palette.studio.borderColor}`,
    background: 'rgba(81,91,106,0.15)',
    width: 'calc(100% - 55px)',
    margin: 0,
  },
  mainControl: {
    borderRight: `1px solid ${palette.studio.borderColor}`,
    width: 'calc(100% - 55px)',
  },
  settingActionContainer: {
    padding: '12px 6px !important',
    maxWidth: 55,
  },
  syncPrompterRoot:{
    paddingTop: 0,
    marginTop: 16
  },
  panelSettingsContainer: {
    display: 'flex',
  },
  button: {
    border: `1px solid ${palette.studio.borderColor}`,
    borderRadius: '3px',
    color: '#FFF',
    width: '100%',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: 'rgba(81,91,106,0.5)',
    },
    minHeight: 42,
    minWidth: 42,
    fontFamily: 'Montserrat',
    fontSize: '16px',
  },
  disabledButton: {
    background: palette.studio.disabledAction,
  },
  buttonPanel: {
    '& button': {
      marginRight: '12px',
    },
  },
  fontSizeButtonsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  fontSizeButtonWrapper: {
    marginRight: '12px',
  },
  fontSizeButton: {
    minHeight: '39px',
    height: '39px',
  },
  playButton: {
    background: '#FFF',
    '&:hover': {
      backgroundColor: '#FFF',
    },
  },
  circleButton: {
    borderRadius: '50%',
  },
  label: {
    fontSize: '12px',
    color: '#FFF',
    margin: 0,
    padding: '0 0 5px 0',
  },
  icon: {
    height: '16px',
    color: '#FFF',
    verticalAlign: 'middle',
  },
  autoScrollIcon: {
    color: palette.studio.background,
  },
  exitButtonWrapper: {
    width: 150,
    [breakpoints.down(360)]: {
      order: 3,
    },
  },
  exitButton: {
    color: palette.studio.borderColor,
  },
  labelControl: {
    fontSize: '16px',
    color: '#FFF',
  },
  labelRoot: {
    marginRight: 14,
  },
  countdownDelayLabel: {
    minWidth: '40px',
    marginRight: '20px',
    fontSize: '30px',
    color: '#FFF',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      marginRight: '0px',
    },
  },

  activeButton: {
    background: palette.studio.action,
    '&:hover': {
      backgroundColor: 'rgba(116, 124,153, 0.5)',
    },
  },
  audioMeter: {
    width: '100%',
    maxWidth: 120,
    minWidth: 90,
    height: '12px',
    borderRadius: '6px',
    backgroundColor: palette.studio.track,
    [breakpoints.down(470)]: {
      width: '80px',
    },
  },
  audioMeterDebug: {
    height: '50px',
  },
  selectionWrapper: {
    [breakpoints.down(368)]: {
      width: '100%',
    },
  },
  selectionWrapperGuide: {
    marginRight: 16,
    [breakpoints.down(368)]: {
      marginRight: 0,
    },
  },
  selection: {
    color: '#FFF',
    maxWidth: '100%',
    width: 248,
    '& svg': {
      color: '#FFF',
    },
    '&.Mui-disabled': {
      color: '#515B6A !important',
    },
  },
  slider: {
    [breakpoints.down(529)]: {
      width: '100%',
      maxWidth: 248,
      flexGrow: 4,
    },
  },
  delayStartSelect: {
    width: '130px',
    minWidth: 'auto',
    [breakpoints.down(529)]: {
      width: 248,
    },
    [breakpoints.down(368)]: {
      width: '100%',
    },
  },
  delayStartSelectCamera: {
    width: '100%',
  },
  link: {
    textDecoration: 'unset',
    '&:hover': {
      textDecoration: 'unset',
    },
  },
  background: {
    backgroundColor: palette.studio.background,
  },
  text: {
    color: '#FFF',
    fontFamily: 'Montserrat',
    fontSize: '16px',
  },
  title: {
    fontSize: '24px',
  },
  center: {
    textAlign: 'center',
  },
  plusIcon: {
    height: 8,
    width: 8,
    position: 'absolute',
    top: -3,
    right: 0,
  },
  notify: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    color: '#FFF',
    background: palette.studio.background,
    borderBottomColor: palette.studio.borderColor,
    borderBottom: 'solid 3px',
    minHeight: 50,
    padding: '0 25px 0 10px',
  },
  bookmarkIcon: {
    height: 24,
    verticalAlign: 'middle',
  },
  disabledSelect: {
    color: '#B4B4B4 !important',
    background: 'rgba(255,255,255,0.15)',
  },
  disabledSwitch: {
    '& .MuiButtonBase-root': {
      color: '#c1c1c1 !important',
    },
    '& .MuiSwitch-track': {
      transitionDuration: '0s',
      background: '#5d6181 !important',
    },
  },
  disabledSwitchLabel: {
    color: 'rgba(255,255,255,0.7) !important',
  },
  tooltip: {
    position: 'relative',
    backgroundColor: '#515B6A',
    fontSize: 12,
  },

  tooltipPopper: {
    zIndex: 2147483102,
  },

  reactTooltip: {
    cursor: 'pointer !important',
    padding: '3px 6px !important',
    backgroundColor: '#515B6A !important',
    fontSize: '12px !important',
    maxWidth: '65vw !important',
    visibility: 'hidden',
    opacity: '0 !important',
    transition: 'opacity 0.3s ease',
    '&.show': {
      opacity: '1 !important',
      visibility: 'visible',
    },
  },
  smallButtonContainer: {
    width: 58,
    [breakpoints.down(360)]: {
      order: 2,
    },
  },
  studioControlWrapper: {
    userSelect: 'none',
  },
  mainActionContainer: {
    padding: '6px !important',
    maxWidth: '100%',
    maxHeight: 78,
    overflow: 'hidden',
    textAlign: 'center',
  },
  mainActionTitle: {
    fontSize: 10,
  },
  recordIcon: {
    color: '#F8221A',
  },

  disabledRecordIcon: {
    color: '#515B6A',
    height: '2rem',
  },

  disabledRecordButton: {
    borderWidth: '4px',
    borderColor: '#515B6A',
  },
  selectAutoWidth: {
    minWidth: 'unset',
  },
  studioBottomView: {
    height: PrompterConfig.minHeightPrompter,
    marginTop: 16,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: palette.studio.borderColor,
    backgroundColor: palette.studio.background,
    color: 'rgba(255, 255, 255, 1) !important',
    overflow: 'hidden',
    position: 'relative',
  },
  timer: {
    fontSize: 19,
    fontFamily: 'Montserrat',
    padding: '0 0 0 8px !important',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  audioSelectContainer: {
    marginTop: 16,
  }
}), { name: 'StudioControls' });

export const PromptTextStyles = makeStyles(({ palette }: Theme) => createStyles({
  container: {
    width: '100%',
    fontSize: '36px',
    color: 'white',
    height: '80vh',
    overflow: 'auto',
    // whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    padding: '20px 20px 20px 30px',
    '& .ce-block__content': {
      maxWidth: 'unset !important',
    },
    '& p, span': {
      fontSize: 'inherit !important',
    },
    '& .cdx-block': {
      padding: 'unset !important',
      marginBottom: 10,
    },
  },
  textHighlightBar: {
    position: 'absolute',
    left: 20,
    right: 20,
    top: 10,
    height: '50px',
    background: palette.studio.guide,
    border: `1px solid ${palette.studio.guideBorder}`,
  },
  guideContainer: {
    position: 'absolute',
    maxWidth: '900px',
    width: '100%',
    margin: 'auto',
    left: 0,
    right: 0,
    top: '10px',
  },
  noselect: {
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
}), { name: 'PromptText' });

export const studioModalStyles = makeStyles(({ palette, breakpoints }: Theme) => ({
  root: {
    maxWidth: '630px',
    padding: '80px 108px 86px',
    border: 'none',
    backgroundColor: palette.studio.background,
    position: 'relative',
    color: '#fff',
    fontFamily: 'Montserrat',

    [breakpoints.down('sm')]: {
      maxWidth: '500px',
      padding: '21px 38px 50px',
      height: '240px',
    },
  },

  title: {
    textAlign: 'center',
    '& h2': {
      fontSize: '1.5rem',
      fontFamily: 'Montserrat',

      [breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    },
  },

  content: {
    [breakpoints.down('sm')]: {
      padding: 0,
    },
  },

  description: {
    textAlign: 'center',
    fontSize: '1rem',
    color: '#fff',
    marginBottom: '45px',
    [breakpoints.down('sm')]: {
      fontSize: '0.75rem',
      marginBottom: 0,
    },
  },

  button: {
    textTransform: 'none',
    fontSize: '1rem',
    width: '189px',
    borderWidth: '1px',
    borderRadius: '5px',
    color: '#fff',
    borderStyle: 'solid',

    [breakpoints.down('sm')]: {
      width: '130px',
      fontSize: '0.8rem',
    },

    '&.confirm': {
      backgroundColor: 'rgba(248,34,26,0.5)',
      borderColor: '#F8221A',
    },
    '&.cancel': {
      backgroundColor: 'rgba(1,179,197,0.5)',
      borderColor: '#01B3C5',
    },
    '&.cancel-neutral': {
      borderColor: '#747C99',
      backgroundColor: 'rgba(0,0,0,0)',
      '&:hover': {
        backgroundColor: palette.buttonSingle.hover,
        borderColor: palette.buttonSingle.hover,
      },
      '&:active': {
        backgroundColor: palette.buttonSingle.hover,
        borderColor: palette.buttonSingle.hover,
      },
    },
  },
}), { name: 'StudioModal' });

export const StudioComponentStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    width: '90%',
    maxWidth: '900px',
    margin: '0 auto',
    marginTop: '10px',
    marginBottom: '10px',
    padding: 0,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: palette.studio.borderColor,
    backgroundColor: palette.studio.background,
    color: 'rgba(255, 255, 255, 1) !important',
    position: 'relative',
  },
}), { name: 'StudioComponent' });

export const studioPreventChangeRouteModalStyles = makeStyles(({ palette }:Theme) => ({
  wrapper: {
    backgroundColor: palette.studio.background,
  },
  title: {
    color: '#fff !important',
  },
  text: {
    color: '#fff',
  },
  actionWrapper: {
    backgroundColor: palette.studio.background,
  },
  cancelButton: {
    backgroundColor: 'rgba(248,34,26,0.5)',
    borderColor: '#F8221A',
    color: '#fff !important',
  },
  approveButton: {
    backgroundColor: 'rgba(1,179,197,0.5)',
    borderColor: '#01B3C5',
    color: '#fff !important',
  },

}), { name: 'studioPreventChangeRouteModalStyles' });
